module.exports = __webpack_public_path__ + "img/image_15.a21f12ec.png";